import { Action } from '../actions';

const defaultState = {
};

export function users(userState = defaultState, action) {
  switch (action.type) {
    case Action.Identity.Users.SearchRequestedCompleted:
      return {
        ...userState,
        accounts: action.payload.body,
      };
    default:
      break;
  }
  return userState;
}
